import {
  Grid,
  FormControl,
  Typography,
  TextField,
  FormHelperText,
  Autocomplete,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import HeaderPage from "../../components/HeaderPage/Index";
import { isMobile } from "react-device-detect";
import { getData, storeData, checkEditPage } from "../../utils/GlobalHelper";
import GlobalApi from "../../utils/GlobalApi";
import { isEmpty } from "lodash";
import Loading from "../../components/loading/loading";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import Configs from "../../constants/Configs";
import DialogCustoms from "../../components/CustomDialog/DialogCustoms";
import PanelScrollBar from "../../components/BoxRightContent/PanelScrollBar";
import { mooFormat } from "../../utils/formatter";

const header = {
  headers: {
    "Content-Type": "application/json",
  },
};
const CurrentAddress = (props) => {
  const [lang, setLang] = useState(getData("lang"));
  const [translations, setTranslations] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isModalErr, setIsModalErr] = useState(false);
  const [titleModalErr, setTitleModalErr] = useState("");
  const [msgModalErr, setMsgModalErr] = useState("");
  const [editUrl, setEditUrl] = useState(false);
  const [jumpPage, setJumpPage] = useState(false);
  // Current address
  const [selectRadio, setSelectRadio] = useState("");
  const [houseNo, setHouseNo] = useState("");
  const [moo, setMoo] = useState("");
  const [building, setBuilding] = useState("");
  const [floor, setFloor] = useState("");
  const [alley, setAlley] = useState("");
  const [road, setRoad] = useState("");
  const [province, setProvince] = useState({});
  const [district, setDistrict] = useState({});
  const [subDistrict, setSubDistrict] = useState({});
  const [zipcode, setZipcode] = useState({});
  const country = "212";
  // Text Error
  const [houseNoErr, setHouseNoErr] = useState("");
  const [mooErr, setMooErr] = useState("");
  const [provinceErr, setProvinceErr] = useState("");
  const [districtErr, setDistrictErr] = useState("");
  const [subDistrictErr, setSubDistrictErr] = useState("");
  const [zipcodeErr, setZipcodeErr] = useState("");
  // Options data
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [subDistricts, setSubDistricts] = useState([]);
  const [zipcodes, setZipcodes] = useState([]);
  // LocalStorage data
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const checkuserinfo = getData("checkuserinfo");
  const f2IdcAddr = getData("f2_idc_address");
  const f2 = getData("f2_current_address");
  const f2WorkAddr = getData("f2_workplace_address");
  const f2DocAddr = getData("f2_document_address");
  let uploadImg = getData("uploadImage");

  var provId = "";
  var distId = "";

  const checkJumpPage = async () => {
    const questions = getData("questionsAnswer");
    const pageAgree = getData("page_agree");
    const idc = getData("idc");
    await getImage();

    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(uploadImg) ||
      isEmpty(idc) ||
      isEmpty(f2IdcAddr)
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  uploadImg = element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  const checkEditUrl = async () => {
    checkEditPage().then((res) => {
      res ? setEditUrl(true) : setEditUrl(false);
    });
  };
  const callGetProvince = async () => {
    setIsLoading(true);
    try {
      await GlobalApi.get(
        `${Configs.baseAPIURL03}/constant/province/${country}`,
      )
        .then((res) => {
          if (res.data) {
            let data = res.data.Data;
            setProvinces(data);
            if (!isEmpty(f2.f2_current_province)) {
              data.forEach((ele) => {
                if (ele.Id === f2.f2_current_province) {
                  provId = ele.Id;
                  setProvince(ele);
                  callGetDistrict(ele.Id, "onload");
                  setIsEnabled(true);
                }
              });
            }
            setIsLoading(false);
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };
  const callGetDistrict = async (id, type) => {
    setIsLoading(true);
    try {
      await GlobalApi.get(`${Configs.baseAPIURL03}/constant/district/${id}`)
        .then((res) => {
          if (res.data) {
            let data = res.data.Data;
            setDistricts(data);
            if (!isEmpty(f2.f2_current_district) && type === "onload") {
              data.forEach((ele) => {
                if (ele.Id === f2.f2_current_district) {
                  distId = ele.Id;
                  setDistrict(ele);
                  callGetSubDistrict(ele.Id, type);
                  setIsEnabled(true);
                }
              });
            }
            setIsLoading(false);
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };
  const callGetSubDistrict = async (id, type) => {
    setIsLoading(true);
    try {
      await GlobalApi.get(`${Configs.baseAPIURL03}/constant/subdistrict/${id}`)
        .then((res) => {
          if (res.data) {
            let data = res.data.Data;
            setSubDistricts(data);
            if (!isEmpty(f2.f2_current_subdistrict) && type === "onload") {
              data.forEach((ele) => {
                if (ele.Id === f2.f2_current_subdistrict) {
                  setSubDistrict(ele);
                  callGetZipcode(ele.Id, type);
                  setIsEnabled(true);
                }
              });
            }
            setIsLoading(false);
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };
  const callGetZipcode = async (id, type) => {
    setIsLoading(true);
    try {
      await GlobalApi.get(
        `${Configs.baseAPIURL03}/constant/postcode/${country}/${
          province.Id ? province.Id : provId
        }/${district.Id ? district.Id : distId}/${id}`,
      )
        .then((res) => {
          if (res.data) {
            let data = res.data.Data;
            setZipcodes(data);
            if (!isEmpty(f2.f2_current_zipcode) && type === "onload") {
              data.forEach((ele) => {
                if (ele.PostCode === f2.f2_current_zipcode) {
                  setZipcode(ele);
                  setIsEnabled(true);
                }
              });
            } else {
              data.forEach((ele, i) => {
                if (i === 0) {
                  setZipcode(ele);
                  setIsEnabled(true);
                }
              });
            }
            setIsLoading(false);
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };
  const updateTracking = async (data) => {
    let upd = false;
    if (!isEmpty(data)) {
      try {
        await GlobalApi.post(
          Configs.baseAPIURL03 + "/form/header/update_tracking",
          data,
        )
          .then((res) => {
            let result = res.data.Data[0][0];
            upd = result.MsgDesc.includes("Success") ? true : false;
          })
          .catch((error) => {
            if (!!error.isAxiosError && !error.response) {
              setTitleModalErr("เกิดข้อผิดพลาด");
              setMsgModalErr("กรุณาทำรายการใหม่อีกครั้ง");
              setIsModalErr(true);
            } else {
              let errorMessage = error.response
                ? error.response.data.message
                : "";
              setTitleModalErr("เกิดข้อผิดพลาด");
              setMsgModalErr(`axios or api error ${errorMessage}`);
              setIsModalErr(true);
            }
          });
      } catch (error) {
        setTitleModalErr("เกิดข้อผิดพลาด");
        setMsgModalErr("กรุณาทำรายการใหม่อีกครั้ง");
        setIsModalErr(true);
      }
    }
    return upd;
  };
  const onInitData = async () => {
    let isHave = true;
    if (!isEmpty(f2)) {
      if (
        f2.f2_current_no === f2IdcAddr.f2_nric_no &&
        f2.f2_current_moo === f2IdcAddr.f2_nric_moo &&
        f2.f2_current_building === f2IdcAddr.f2_nric_building &&
        f2.f2_current_floor === f2IdcAddr.f2_nric_floor &&
        f2.f2_current_alley === f2IdcAddr.f2_nric_alley &&
        f2.f2_current_road === f2IdcAddr.f2_nric_road &&
        f2.f2_current_province === f2IdcAddr.f2_nric_province &&
        f2.f2_current_district === f2IdcAddr.f2_nric_district &&
        f2.f2_current_subdistrict === f2IdcAddr.f2_nric_subdistrict &&
        f2.f2_current_zipcode === f2IdcAddr.f2_nric_zipcode &&
        f2.f2_current_country === f2IdcAddr.f2_nric_country
      ) {
        setSelectRadio("0");
      } else {
        setSelectRadio("1");
        if (!isEmpty(f2.f2_current_no)) {
          setHouseNo(f2.f2_current_no);
        } else {
          setHouseNo("");
          isHave = false;
        }
        if (!isEmpty(f2.f2_current_moo)) {
          setMoo(f2.f2_current_moo);
        } else {
          setMoo("");
          isHave = false;
        }
        if (!isEmpty(f2.f2_current_building)) {
          setBuilding(f2.f2_current_building);
        } else {
          setBuilding("");
          isHave = false;
        }
        if (!isEmpty(f2.f2_current_floor)) {
          setFloor(f2.f2_current_floor);
        } else {
          setFloor("");
          isHave = false;
        }
        if (!isEmpty(f2.f2_current_alley)) {
          setAlley(f2.f2_current_alley);
        } else {
          setAlley("");
          isHave = false;
        }
        if (!isEmpty(f2.f2_current_road)) {
          setRoad(f2.f2_current_road);
        } else {
          setRoad("");
          isHave = false;
        }
      }
    } else {
      isHave = false;
    }
    setIsEnabled(isHave);
  };
  const handleChangeRadio = (e) => {
    setSelectRadio(e.target.value);
    setIsEnabled(true);
    if (e.target.value === "1") {
      setProvince({});
      setDistrict({});
      setSubDistrict({});
      setZipcode({});
    }
  };
  const handleChangeHouseNo = (e) => {
    setHouseNoErr("");
    if (!isEmpty(e.target.value)) {
      setHouseNo(e.target.value);
    } else {
      setHouseNo("");
    }
  };
  const handleChangeMoo = (e) => {
    setMooErr("");
    if (!isEmpty(e.target.value)) {
      setMoo(e.target.value);
    } else {
      setMoo("");
    }
  };
  const handleChangeBuilding = (e) => {
    if (!isEmpty(e.target.value)) {
      setBuilding(e.target.value);
    } else {
      setBuilding("");
    }
  };
  const handleChangeFloor = (e) => {
    if (!isEmpty(e.target.value)) {
      setFloor(e.target.value);
    } else {
      setFloor("");
    }
  };
  const handleChangeSoi = (e) => {
    if (!isEmpty(e.target.value)) {
      setAlley(e.target.value);
    } else {
      setAlley("");
    }
  };
  const handleChangeStreet = (e) => {
    if (!isEmpty(e.target.value)) {
      setRoad(e.target.value);
    } else {
      setRoad("");
    }
  };
  const handleChangeProvince = (e, value) => {
    setDistrict({});
    setSubDistrict({});
    setZipcode({});
    if (!isEmpty(value)) {
      provId = value.Id;
      setProvince(value);
      setIsEnabled(true);
      callGetDistrict(provId, "onchange");
    } else {
      provId = "";
      setProvince({});
      setDistricts([]);
      setSubDistricts([]);
      setZipcodes([]);
    }
  };
  const handleChangeDistrict = (e, value) => {
    setSubDistrict({});
    setZipcode({});
    if (!isEmpty(value)) {
      distId = value.Id;
      setDistrict(value);
      setIsEnabled(true);
      callGetSubDistrict(distId, "onchange");
    } else {
      distId = "";
      setDistrict({});
      setSubDistricts([]);
      setZipcodes([]);
    }
  };
  const handleChangeSubDistrict = (e, value) => {
    setSubDistrict({});
    setZipcode({});
    if (!isEmpty(value)) {
      setSubDistrict(value);
      setIsEnabled(true);
      callGetZipcode(value.Id, "onchange");
    } else {
      setSubDistrict({});
      setZipcodes([]);
    }
  };
  const handleChangeZipcode = (e, value) => {
    if (!isEmpty(value)) {
      setZipcode(value);
      setIsEnabled(true);
    } else {
      setZipcode({});
    }
  };
  const setTextSummary = async (type, data) => {
    let setMoo = !isEmpty(moo) ? `หมู่ ${moo}` : "";
    let setBuilding = !isEmpty(building) ? `อาคาร/หมู่บ้าน ${building}` : "";
    let setFloor = !isEmpty(floor) ? `ชั้น ${floor}` : "";
    let setAlley = !isEmpty(alley) ? `ซอย ${alley}` : "";
    let setRoad = !isEmpty(road) ? `ถนน ${road}` : "";
    let text =
      houseNo +
      " " +
      setMoo +
      " " +
      setBuilding +
      " " +
      setFloor +
      " " +
      setAlley +
      " " +
      setRoad +
      " แขวง/ตำบล " +
      subDistrict.ThName +
      " เขต/อำเภอ " +
      district.ThName +
      " จังหวัด " +
      province.ThName +
      " " +
      zipcode.PostCode;
    let txt = type === "idc" ? getData("text_idc_address") : text;
    storeData("text_current_address", txt);
    storeData("f2_current_address", data);
    if (editUrl) {
      let preData = {
        head_token,
        f2_nric_no: f2IdcAddr.f2_nric_no,
        f2_nric_moo: f2IdcAddr.f2_nric_moo,
        f2_nric_building: f2IdcAddr.f2_nric_building,
        f2_nric_floor: f2IdcAddr.f2_nric_floor,
        f2_nric_alley: f2IdcAddr.f2_nric_alley,
        f2_nric_road: f2IdcAddr.f2_nric_road,
        f2_nric_province: f2IdcAddr.f2_nric_province,
        f2_nric_district: f2IdcAddr.f2_nric_district,
        f2_nric_subdistrict: f2IdcAddr.f2_nric_subdistrict,
        f2_nric_zipcode: f2IdcAddr.f2_nric_zipcode,
        f2_nric_country: f2IdcAddr.f2_nric_country,

        f2_current_no: data.f2_current_no,
        f2_current_moo: data.f2_current_moo,
        f2_current_building: data.f2_current_building,
        f2_current_floor: data.f2_current_floor,
        f2_current_alley: data.f2_current_alley,
        f2_current_road: data.f2_current_road,
        f2_current_province: data.f2_current_province,
        f2_current_district: data.f2_current_district,
        f2_current_subdistrict: data.f2_current_subdistrict,
        f2_current_zipcode: data.f2_current_zipcode,
        f2_current_country: data.f2_current_country,

        f2_workplace_no: f2WorkAddr.f2_workplace_no,
        f2_workplace_moo: f2WorkAddr.f2_workplace_moo,
        f2_workplace_building: f2WorkAddr.f2_workplace_building,
        f2_workplace_floor: f2WorkAddr.f2_workplace_floor,
        f2_workplace_alley: f2WorkAddr.f2_workplace_alley,
        f2_workplace_road: f2WorkAddr.f2_workplace_road,
        f2_workplace_province: f2WorkAddr.f2_workplace_province,
        f2_workplace_district: f2WorkAddr.f2_workplace_district,
        f2_workplace_subdistrict: f2WorkAddr.f2_workplace_subdistrict,
        f2_workplace_zipcode: f2WorkAddr.f2_workplace_zipcode,
        f2_workplace_country: f2WorkAddr.f2_workplace_country,

        f2_doc_address: f2DocAddr.f2_doc_address,
      };
      postData(preData);
    } else {
      props.history.push("/workplace_address");
    }
  };
  const postData = async (data) => {
    setIsLoading(true);
    try {
      GlobalApi.post(`${Configs.baseAPIURL03}/form/address/manp`, data, header)
        .then((res) => {
          setIsLoading(false);
          if (res.data.Data[0][0].IsSuccess === 1) {
            storeData("editPage", "address");
            props.history.push("/summary");
          }
        })
        .catch((e) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };
  const handleNext = async (e) => {
    e.preventDefault();
    if (selectRadio === "0") {
      let prepareData = {
        f2_current_no: f2IdcAddr.f2_nric_no,
        f2_current_moo: !isEmpty(f2IdcAddr.f2_nric_moo)
          ? f2IdcAddr.f2_nric_moo
          : "",
        f2_current_building: !isEmpty(f2IdcAddr.f2_nric_building)
          ? f2IdcAddr.f2_nric_building
          : "",
        f2_current_floor: !isEmpty(f2IdcAddr.f2_nric_floor)
          ? f2IdcAddr.f2_nric_floor
          : "",
        f2_current_alley: !isEmpty(f2IdcAddr.f2_nric_alley)
          ? f2IdcAddr.f2_nric_alley
          : "",
        f2_current_road: !isEmpty(f2IdcAddr.f2_nric_road)
          ? f2IdcAddr.f2_nric_road
          : "",
        f2_current_province: f2IdcAddr.f2_nric_province,
        f2_current_district: f2IdcAddr.f2_nric_district,
        f2_current_subdistrict: f2IdcAddr.f2_nric_subdistrict,
        f2_current_zipcode: f2IdcAddr.f2_nric_zipcode,
        f2_current_country: f2IdcAddr.f2_nric_country,
      };
      await setTextSummary("idc", prepareData);
    } else {
      let valid = await validate();
      if (valid) {
        let prepareData = {
          f2_current_no: houseNo,
          f2_current_moo: !isEmpty(moo) ? moo : "",
          f2_current_building: !isEmpty(building) ? building : "",
          f2_current_floor: !isEmpty(floor) ? floor : "",
          f2_current_alley: !isEmpty(alley) ? alley : "",
          f2_current_road: !isEmpty(road) ? road : "",
          f2_current_province: province.Id,
          f2_current_district: district.Id,
          f2_current_subdistrict: subDistrict.Id,
          f2_current_zipcode: zipcode.PostCode,
          f2_current_country: country,
        };
        await setTextSummary("cur", prepareData);
      }
    }
  };
  const validate = async () => {
    let valid = true;
    if (isEmpty(houseNo)) {
      setHouseNoErr("กรุณาระบุบ้านเลขที่");
      valid = false;
    }
    // else {
    //   if (!houseNoFormat(houseNo)) {
    //     setHouseNoErr("กรุณาระบุบ้านเลขที่ให้ถูกต้อง");
    //     valid = false;
    //   }
    // }
    if (!isEmpty(moo) && !mooFormat(moo)) {
      setMooErr("กรุณาระบุหมู่ที่ให้ถูกต้อง");
      valid = false;
    }
    if (isEmpty(province)) {
      setProvinceErr("กรุณาระบุจังหวัด");
      valid = false;
    }
    if (isEmpty(district)) {
      setDistrictErr("กรุณาระบุเขต/อำเภอ");
      valid = false;
    }
    if (isEmpty(subDistrict)) {
      setSubDistrictErr("กรุณาระบุแขวง/ตำบล");
      valid = false;
    }
    if (isEmpty(zipcode)) {
      setZipcodeErr("กรุณาระบุรหัสไปรษณีย์");
      valid = false;
    }
    if (!isEmpty(district)) {
      if (district.RiskGroup === 3) {
        // Risk3
        storeData("riskGroupCurrent", true);
        //
        // valid = false;
        let data = {};
        data.head_token = !isEmpty(head_token) ? head_token : "";
        data.card_id = !isEmpty(checkuserinfo?.cardId)
          ? checkuserinfo?.cardId
          : "";
        data.stamp_page = "9";
        data.error_code = "3004";
        let upd = await updateTracking(data);
        if (upd) {
          // setIsModal(true);
          // setProvince({});
          // setDistrict({});
          // setSubDistrict({});
          // setZipcode({});
          // setDistricts([]);
          // setSubDistricts([]);
          // setZipcodes([]);
        }
      } else {
        storeData("riskGroupCurrent", false);
      }
    }
    return valid;
  };

  useEffect(() => {
    checkJumpPage().then((res) => {
      if (res) {
        setJumpPage(true);
      } else {
        const translation = getData("Translations");
        if (!isEmpty(translation)) {
          setTranslations(translation);
        } else {
          props.history.push("/");
        }
        checkEditUrl();
        callGetProvince();
        onInitData();
      }
    });
  }, []);
  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.home?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) => (e ? props.history.push("/address") : "")}
          />
          <Loading status={isLoading} />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.currentAddress}
                        clickBack={(e) => props.history.push("/address")}
                        editUrl={editUrl}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: isMobile ? "100%" : "100%",
                          }}
                        >
                          <HeaderRight
                            title={translations?.[lang]?.currentAddress?.title}
                          />
                          <PanelScrollBar
                            size="full"
                            content={
                              <>
                                <Grid>
                                  <Typography className="text-primary font-weight-bold font-20">
                                    {
                                      translations?.[lang]?.currentAddress
                                        ?.sub_title
                                    }
                                  </Typography>
                                </Grid>
                                <Grid className="input-form">
                                  <FormControl fullWidth>
                                    <RadioGroup
                                      className="font-20"
                                      aria-label="typeAddress"
                                      name="controlled-radio-buttons-group"
                                      value={selectRadio}
                                      onChange={handleChangeRadio}
                                    >
                                      <FormControlLabel
                                        value="0"
                                        control={<Radio />}
                                        label="ตามที่อยู่ตามบัตรประจำตัวประชาชน"
                                      />
                                      <Grid className="line-gray"></Grid>
                                      <FormControlLabel
                                        value="1"
                                        control={<Radio />}
                                        label="ที่อยู่อื่น"
                                      />
                                      <Grid className="line-gray"></Grid>
                                    </RadioGroup>
                                  </FormControl>
                                </Grid>
                                {selectRadio === "1" && (
                                  <>
                                    <Grid className="input-form">
                                      <FormControl fullWidth error>
                                        <TextField
                                          className="font-20"
                                          variant="standard"
                                          label="บ้านเลขที่"
                                          value={houseNo}
                                          onChange={handleChangeHouseNo}
                                          required
                                        />
                                        <FormHelperText className="text-error">
                                          {houseNoErr}
                                        </FormHelperText>
                                      </FormControl>
                                    </Grid>
                                    <Grid container spacing={2}>
                                      <Grid item xs={8}>
                                        <Grid className="input-form">
                                          <FormControl fullWidth error>
                                            <TextField
                                              className="font-20"
                                              variant="standard"
                                              label="หมู่ที่"
                                              value={moo}
                                              onChange={handleChangeMoo}
                                            />
                                            <FormHelperText className="text-error">
                                              {mooErr}
                                            </FormHelperText>
                                          </FormControl>
                                        </Grid>
                                      </Grid>
                                      <Grid item xs={8}>
                                        <Grid className="input-form" item>
                                          <FormControl fullWidth>
                                            <TextField
                                              className="font-20"
                                              variant="standard"
                                              label="อาคาร/หมู่บ้าน"
                                              value={building}
                                              onChange={handleChangeBuilding}
                                            />
                                          </FormControl>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                      <Grid item xs={8}>
                                        <Grid className="input-form">
                                          <FormControl fullWidth>
                                            <TextField
                                              className="font-20"
                                              variant="standard"
                                              label="ชั้น"
                                              value={floor}
                                              onChange={handleChangeFloor}
                                            />
                                          </FormControl>
                                        </Grid>
                                      </Grid>
                                      <Grid item xs={8}>
                                        <Grid className="input-form" item>
                                          <FormControl fullWidth>
                                            <TextField
                                              className="font-20"
                                              variant="standard"
                                              label="ซอย"
                                              value={alley}
                                              onChange={handleChangeSoi}
                                            />
                                          </FormControl>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid className="input-form">
                                      <FormControl fullWidth>
                                        <TextField
                                          className="font-20"
                                          variant="standard"
                                          label="ถนน"
                                          value={road}
                                          onChange={handleChangeStreet}
                                        />
                                      </FormControl>
                                    </Grid>
                                    <Grid className="input-form">
                                      <FormControl
                                        variant="standard"
                                        fullWidth
                                        error
                                      >
                                        <Autocomplete
                                          options={provinces}
                                          value={province}
                                          getOptionLabel={(option) =>
                                            option.ThName ? option.ThName : ""
                                          }
                                          onChange={(e, value) =>
                                            handleChangeProvince(e, value)
                                          }
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              InputProps={{
                                                ...params.InputProps,
                                                // readOnly: true,
                                              }}
                                              variant="standard"
                                              label="จังหวัด"
                                              required
                                            />
                                          )}
                                        />
                                        <FormHelperText className="text-error">
                                          {provinceErr}
                                        </FormHelperText>
                                      </FormControl>
                                    </Grid>
                                    <Grid className="input-form">
                                      <FormControl
                                        variant="standard"
                                        fullWidth
                                        error
                                      >
                                        <Autocomplete
                                          options={districts}
                                          value={district}
                                          disabled={
                                            isEmpty(province) ? true : false
                                          }
                                          getOptionLabel={(option) =>
                                            option.ThName ? option.ThName : ""
                                          }
                                          onChange={(e, value) =>
                                            handleChangeDistrict(e, value)
                                          }
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              InputProps={{
                                                ...params.InputProps,
                                                // readOnly: true,
                                              }}
                                              variant="standard"
                                              label="เขต/อำเภอ"
                                              required
                                            />
                                          )}
                                        />
                                        <FormHelperText className="text-error">
                                          {districtErr}
                                        </FormHelperText>
                                      </FormControl>
                                    </Grid>
                                    <Grid className="input-form">
                                      <FormControl
                                        variant="standard"
                                        fullWidth
                                        error
                                      >
                                        <Autocomplete
                                          options={subDistricts}
                                          value={subDistrict}
                                          disabled={
                                            isEmpty(district) ? true : false
                                          }
                                          getOptionLabel={(option) =>
                                            option.ThName ? option.ThName : ""
                                          }
                                          onChange={(e, value) =>
                                            handleChangeSubDistrict(e, value)
                                          }
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              InputProps={{
                                                ...params.InputProps,
                                                // readOnly: true,
                                              }}
                                              variant="standard"
                                              label="แขวง/ตำบล"
                                              required
                                            />
                                          )}
                                        />
                                        <FormHelperText className="text-error">
                                          {subDistrictErr}
                                        </FormHelperText>
                                      </FormControl>
                                    </Grid>
                                    <Grid className="input-form">
                                      <FormControl
                                        variant="standard"
                                        fullWidth
                                        error
                                      >
                                        <Autocomplete
                                          options={zipcodes}
                                          value={zipcode}
                                          disabled={
                                            isEmpty(subDistrict) ? true : false
                                          }
                                          getOptionLabel={(option) =>
                                            option.PostCode
                                              ? option.PostCode
                                              : ""
                                          }
                                          onChange={(e, value) =>
                                            handleChangeZipcode(e, value)
                                          }
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              InputProps={{
                                                ...params.InputProps,
                                                // readOnly: true,
                                              }}
                                              variant="standard"
                                              label="รหัสไปรษณีย์"
                                              required
                                            />
                                          )}
                                        />
                                        <FormHelperText className="text-error">
                                          {zipcodeErr}
                                        </FormHelperText>
                                      </FormControl>
                                    </Grid>
                                    <Grid className="input-form">
                                      <FormControl fullWidth>
                                        <TextField
                                          className="font-20"
                                          variant="standard"
                                          label="ประเทศ"
                                          defaultValue="ไทย"
                                          disabled={true}
                                          required
                                        />
                                      </FormControl>
                                    </Grid>
                                  </>
                                )}
                              </>
                            }
                          />
                          <ButtonRight
                            isDisbled
                            disbled={isEnabled}
                            text={
                              editUrl
                                ? "บันทึกการแก้ไข"
                                : translations?.[lang]?.currentAddress?.next
                            }
                            onNextPage={handleNext}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <DialogCustoms
            imgModalError={true}
            open={isModal}
            isModel={setIsModal}
            title={"ขออภัย"}
            massage={
              "ไม่สามารถเปิดบัญชีออนไลน์ได้ กรุณาติดต่อ DAOL Contact Center 0 2351 1800"
            }
            btnPrimary={"ตกลง"}
          />
          <DialogCustoms
            open={isModalErr}
            isModel={setIsModalErr}
            title={titleModalErr}
            massage={msgModalErr}
            btnPrimary={"ตกลง"}
          />
        </>
      )}
    </>
  );
};
export default memo(CurrentAddress);
